import { HiOutlineArchiveBoxXMark } from 'react-icons/hi2'

type EmptyStateTableProps = {
  colSpan: number
  text?: string
}

export const TableEmptyState = ({
  colSpan,
  text = 'No Data Found',
}: EmptyStateTableProps) => {
  return (
    <tr>
      <td colSpan={colSpan}>
        <div className='flex w-full flex-col items-center justify-center p-5 text-gray-500'>
          <HiOutlineArchiveBoxXMark className='h-12 w-12' />
          <h3 className='mt-1 font-semibold'>{text}</h3>
        </div>
      </td>
    </tr>
  )
}
